import 'rxjs'
import { push } from 'react-router-redux'
import uuid from 'uuid'
import { fromJS, Map, List } from 'immutable'
import { Observable } from 'rxjs/Observable'
import { Product, Variation, OrderLine } from '../modules/model'
//Action types
const FETCH_ORDERS_REQUEST = 'ORDERS/FETCH_ORDERS_REQUEST'
const FETCH_ORDERS_SUCCESS = 'ORDERS/FETCH_ORDERS_SUCCESS'
const FETCH_ORDERS_ERROR = 'ORDERS/FETCH_ORDERS_ERROR'
const FETCH_ORDERLINES_REQUEST = 'ORDERS/FETCH_ORDERLINES_REQUEST'
const FETCH_ORDERLINES_SUCCESS = 'ORDERS/FETCH_ORDERLINES_SUCCESS'
const FETCH_ORDERLINES_ERROR = 'ORDERS/FETCH_ORDERLINES_ERROR'
const SUBSCRIBE_ORDERS_REQUEST = 'ORDERS/SUBSCRIBE_ORDERS_REQUEST'

const FETCH_OPTIONS_SUCCESS = 'ORDERS/FETCH_OPTIONS_SUCCESS'
//const FETCH_OPTIONS_ERROR = 'ORDERS/FETCH_OPTIONS_ERROR';

const SELECT_ORDER_TEAM = 'ORDERS/SELECT_ORDER_TEAM'
const SELECT_ORDER_CUSTOMER = 'ORDERS/SELECT_ORDER_CUSTOMER'

const ADD_ORDER_LINE = 'ORDERS/ADD_ORDER_LINE'
const ADD_VARIATION = 'ORDERS/ADD_VARIATION'
const ADD_QUANTITY = 'ORDERS/ADD_QUANTITY'
const ADD_VARIATION_FIELD = 'ORDERS/ADD_VARIATION_FIELD'
const SAVE_ORDER_LINE = 'ORDERS/SAVE_ORDER_LINE'

const EDIT_ORDER_LINE = 'ORDERS/EDIT_ORDER_LINE'
const CANCEL_ORDER_LINE = 'ORDERS/CANCEL_ORDER_LINE'
const DELETE_ORDER_LINE = 'ORDERS/DELETE_ORDER_LINE'
const SET_ORDER_LINE_STATUS = 'ORDERS/SET_ORDER_LINE_STATUS'

const SAVE_ORDER = 'ORDERS/SAVE_ORDER'
const STORE_ORDER = 'ORDERS/STORE_ORDER'
const EDIT_ORDER = 'ORDERS/EDIT_ORDER'
const CANCEL_ORDER = 'ORDERS/CANCEL_ORDER'
const VIEW_ORDER = 'ORDERS/VIEW_ORDER'
const CREATE_NEW_ORDER = 'ORDERS/CREATE_NEW_ORDER'
const DELETE_ORDER = 'ORDERS/DELETE_ORDER'
const PAY_ORDER = 'ORDERS/PAY_ORDER'
const REQUEST_ORDER_PAYMENT = 'ORDERS/REQUEST_ORDER_PAYMENT'
const DELIVER_ORDER = 'ORDERS/DELIVER_ORDER'
const DONE_ORDER = 'ORDERS/DONE_ORDER'
const OPEN_DELETE_ORDER_DIALOG = 'ORDERS/OPEN_DELETE_ORDER_DIALOG'
const CLOSE_DELETE_ORDER_DIALOG = 'ORDERS/CLOSE_DELETE_ORDER_DIALOG'
const SHOW_ALL_ORDERS = 'ORDERS/SHOW_ALL_ORDERS'
const SHOW_PENDING_ORDERS = 'ORDERS/SHOW_PENDING_ORDERS'
const SET_SEARCH_TEXT = 'ORDERS/SET_SEARCH_TEXT'

//Action creators
export const fetchOrdersRequest = () => ({type: FETCH_ORDERS_REQUEST})
export const fetchOrderLinesRequest = () => ({type: FETCH_ORDERLINES_REQUEST})
export const subscribeOrdersRequest = () => ({type: SUBSCRIBE_ORDERS_REQUEST})
export const fetchOrdersSuccess = (orders) => ({type: FETCH_ORDERS_SUCCESS, orders})
const fetchOrderLinesSuccess = (orders) => ({type: FETCH_ORDERLINES_SUCCESS, orders})
// const fetchOrdersError = (error) => ({ type: FETCH_ORDERS_ERROR, error });

export const selectTeamName = (teamName, teamId) => ({type: SELECT_ORDER_TEAM, teamName, teamId})
export const selectCustomerName = (customerName) => ({type: SELECT_ORDER_CUSTOMER, customerName})
export const addOrderLine = (product) => ({type: ADD_ORDER_LINE, product})
export const addVariation = (variation) => ({type: ADD_VARIATION, variation})
export const addQuantity = (quantity) => ({type: ADD_QUANTITY, quantity})
export const addVariationField = (name, value) => ({type: ADD_VARIATION_FIELD, name, value})

export const editOrderLine = (lineId) => ({type: EDIT_ORDER_LINE, lineId})
export const setOrderLineStatus = (orderId, lineId, newStatus) => ({type: SET_ORDER_LINE_STATUS, orderId, lineId, newStatus})
export const cancelOrderLine = () => ({type: CANCEL_ORDER_LINE})

export const saveOrderLine = (orderLine) => ({type: SAVE_ORDER_LINE, orderLine})
export const deleteOrderLine = (lineId) => ({type: DELETE_ORDER_LINE, lineId})

export const newOrder = (order) => ({type: CREATE_NEW_ORDER, order})
export const saveOrder = (order) => ({type: SAVE_ORDER, order})
export const storeOrder = (order) => ({type: STORE_ORDER, order})
export const editOrder = (order) => ({type: EDIT_ORDER, order})
export const cancelOrder = () => ({type: CANCEL_ORDER})
export const viewOrder = (orderId) => ({type: VIEW_ORDER, orderId})
export const deleteOrder = (orderId) => ({type: DELETE_ORDER, orderId})
export const payOrder = (orderId) => ({type: PAY_ORDER, orderId})
export const requestOrderPayment = (order) => ({type: REQUEST_ORDER_PAYMENT, order})
export const deliverOrder = (orderId) => ({type: DELIVER_ORDER, orderId})
export const openDeleteOrderDialog = (order) => ({type: OPEN_DELETE_ORDER_DIALOG, order})
export const closeDeleteOrderDialog = () => ({type: CLOSE_DELETE_ORDER_DIALOG})
export const showAllOrders = (isInputChecked) => ({type: SHOW_ALL_ORDERS, isInputChecked})
export const setSearchText = (searchText) => ({type: SET_SEARCH_TEXT, searchText})

// epic

const handleApiError = error => {
          console.log('error', error)
          return Observable.of({
            type: 'API_ERROR',
            payload: error,
            error: true
          })
        }

export const fetchOrdersEpic = (action$, store, {getOrders}) =>
  action$.ofType(FETCH_ORDERS_REQUEST)
    .mergeMap(action =>
      getOrders()
        .map(response => {
          return fetchOrdersSuccess(response)
        })
    )

export const editOrderEpic = (action$, store, { getOrders }) =>
  action$.ofType(EDIT_ORDER)
    .mergeMap(action => {
      const isLoading = store.getState().getIn(['ordersStore', 'isLoading']);
      let outputAction;
      if (isLoading){
        outputAction = getOrders()
          .concatMap(response => ([fetchOrdersSuccess(response), action ]))
          .catch(handleApiError)
      }else{
        outputAction = Observable.of({type:'NOOP'})
      }
      return outputAction;
    })

export const fetchOrderLinesEpic = (action$, store, {getOrderLines}) =>
  action$.ofType(FETCH_ORDERLINES_REQUEST)
    .mergeMap(action =>
      getOrderLines()
        .map(response => fetchOrderLinesSuccess(response))
        .catch(handleApiError)
    )

export const subscribeOrdersEpic = (action$, store, {subscribeOrders}) =>
  action$.ofType(SUBSCRIBE_ORDERS_REQUEST)
    .mergeMap(action =>
      subscribeOrders()
        .map(response => response !== null ? storeOrder(response) : fetchOrdersRequest())
        .catch(handleApiError)
    )
      
export const payOrderEpic = (action$, store, {saveOrderMutation}) =>
  action$.ofType(REQUEST_ORDER_PAYMENT)
    .mergeMap(action => {
        const order = action.order
        return saveOrderMutation(order)
          .map(response => saveOrder(response))
          .catch(handleApiError)
      }
    )

export const createOrdersEpic = (action$, store) =>
  //epics guarantee to run the actions AFTER the reducers have already processed them
  action$.ofType('CREATE_NEW_ORDERs')
    .map(action => {
      let currentOrderId = store.getState().getIn(['ordersStore', 'currentOrder', 'id'])
      let newAction = push(`/order/${currentOrderId}`)
      return newAction
    })

export const addOrderLineEpic = (action$, store) =>
  action$.ofType(ADD_ORDER_LINE)
    .map(action => {
      let currentOrderId = store.getState().getIn(['ordersStore', 'currentOrder', 'id'])
      let currentOrderLineId = store.getState().getIn(['ordersStore', 'currentOrderLine', 'id'])
      return push(`/order/${currentOrderId}/lines/${currentOrderLineId}`)
    })

export const editOrderLineEpic = (action$, store) =>
  action$.ofType(EDIT_ORDER_LINE)
    .map(action => {
      let currentOrderId = store.getState().getIn(['ordersStore', 'currentOrder', 'id'])
      let currentOrderLineId = store.getState().getIn(['ordersStore', 'currentOrderLine', 'id'])
      return push(`/order/${currentOrderId}/lines/${currentOrderLineId}/details`)
    })

export const setOrderLineStatusEpic = (action$, store, {setOrderLineStatusMutation}) =>
  action$.ofType(SET_ORDER_LINE_STATUS)
    .mergeMap(action => {
        return setOrderLineStatusMutation(action.orderId, action.lineId, action.newStatus)
          .map(response => fetchOrdersRequest())
          .catch(handleApiError)
      }
    )

export const cancelOrderLineEpic = (action$, store) =>
  action$.ofType(CANCEL_ORDER_LINE)
    .map(action => {
      let currentOrderId = store.getState().getIn(['ordersStore', 'currentOrder', 'id'])
      return push(`/order/${currentOrderId}`)
    })

export const saveOrderLineEpic = (action$, store) =>
  action$.ofType(SAVE_ORDER_LINE)
    .map(action => {
      let currentOrderId = store.getState().getIn(['ordersStore', 'currentOrder', 'id'])
      return push(`/order/${currentOrderId}`)
    })

export const saveOrderEpic = (action$, store, {saveOrderMutation}) =>
  action$.ofType(SAVE_ORDER)
    .mergeMap(action => {
      return saveOrderMutation(action.order)
        .map(response => {
          return {type: 'NOOP'}
      })
        .catch(handleApiError)      
    })

export const deleteOrderEpic = (action$, store, {deleteOrderMutation}) =>
  action$.ofType(DELETE_ORDER)
    .mergeMap(action => {
      return deleteOrderMutation(action.orderId)
        .map(response => {
          return {type: 'NOOP'}
        })
        .catch(handleApiError)     
    })

//initial state for this reducer
export const emptyOrder = fromJS({
  id: '',
  customerName: '',
  teamId: '',
  paid: false,
  delivered: false,
  done: false,
  date: '',
  fields: [],
  orderLines: [],
  ui: {
    deleteOrderDialogVisible: false,
  }
})
export const initialState = fromJS({
  orders: [],
  // orderLines: [],
  deleteOrderDialogVisible: false,
  isLoading: false,
  currentOrder: emptyOrder,
  showingAllOrders: false,
  searchText : ''
})


// auxiliary functions

/**
 * This function is called inside the reducer both in SAVE_ORDER and in STORE_ORDER
 * @param {*} state 
 */
const stateSaveOrder = state => responseOrder => {
  let newOrders = state.get('orders')
  const index = newOrders.findIndex(item => item.get('id') === responseOrder.get('id'))
  if (index === -1) {
    newOrders = newOrders.insert(0, responseOrder.set('date', Date.now()))
  } else {
    newOrders = newOrders.update(
      index,
      () => (responseOrder)
    )
  }

  return state.set('orders', newOrders)
  // .set('currentOrder', emptyOrder)
  // .delete('currentOrder')
}

//Reducer
export default function reducer (state = initialState, action) {
  switch (action.type) {
    case FETCH_ORDERS_REQUEST:
      return state.set('isLoading', true).set('teamId', '')
    case FETCH_ORDERS_SUCCESS:
      return state.set('isLoading', false).set('orders', fromJS(action.orders))
    case FETCH_ORDERS_ERROR:
      return state.set('error', action.error).set('isLoading', false)
    case FETCH_ORDERLINES_REQUEST:
      return state.set('isLoading', true)
    case FETCH_ORDERLINES_SUCCESS:
      return state.set('isLoading', false).set('orderLines', fromJS(action.orders))
    case FETCH_ORDERLINES_ERROR:
      return state.set('error', action.error).set('isLoading', false)
    case SELECT_ORDER_TEAM: {
      const team = new Map({
        id: action.teamId,
        name: action.teamName
      })
      const newState = state.setIn(['currentOrder', 'team'], team);
      return newState
    }
    case SELECT_ORDER_CUSTOMER: {
      const currentOrder = state.get('currentOrder').set('customerName', action.customerName)
      const newState = state.set('currentOrder', currentOrder)
      return newState
    }
    case ADD_ORDER_LINE: {
      const currentOrderTeamId = state.getIn(['currentOrder', 'team', 'id'])
      const currentOrderId = state.getIn(['currentOrder', 'id'])
      const jsProduct = action.product.toJS();
      const product = new Product(jsProduct)
      const variation = new Variation({
        product: product
      })
      const orderLine = new OrderLine({
        id: uuid.v4(),
        quantity: 1,
        variation: variation,
        unitPrice: 0.0,
        variationDetails : currentOrderTeamId ? fromJS([{id:`${currentOrderId}_Equipo`, name: 'Equipo', value: currentOrderTeamId}]) : undefined
      })
      const newState = state.set('currentOrderLine', orderLine)
      return newState
    }
    case CANCEL_ORDER_LINE:
      return state.delete('currentOrderLine')
    case ADD_VARIATION: {
      let currentOrdeLine = state.get('currentOrderLine')
        .setIn(['variation', 'id'], action.variation.get('id'))
        .setIn(['variation', 'name'], action.variation.get('name'))
        .setIn(['variation', 'image'], action.variation.get('image'))
        .setIn(['variation', 'fields'], action.variation.get('fields'))
        .set('unitPrice', action.variation.get('price'))
      const newState = state.set('currentOrderLine', currentOrdeLine)
      return newState
    }
    case ADD_QUANTITY:
      return state.setIn(['currentOrderLine', 'quantity'], action.quantity)
    case ADD_VARIATION_FIELD: {
      let newFields = state.getIn(['currentOrderLine', 'variationDetails']) || new List()
      const index = newFields.findIndex(item => item.get('name') === action.name)
      if (index === -1) {
        newFields = newFields.push(Map({name: action.name, value: action.value}))
      } else {
        newFields = newFields.update(
          newFields.findIndex(function (item) {
            return item.get('name') === action.name
          }), function (item) {
            return item.set('value', action.value)
          }
        )
      }
      return state.setIn(['currentOrderLine', 'variationDetails'], newFields)
    }
    case SAVE_ORDER_LINE: {
      let newOrderLines = state.getIn(['currentOrder', 'orderLines'])
      const index = newOrderLines.findIndex(item => item.get('id') === action.orderLine.get('id'))
      if (index === -1) {
        newOrderLines = newOrderLines.push(action.orderLine)
      } else {
        newOrderLines = newOrderLines.update(
          index,
          () => (action.orderLine)
        )
      }
      return state
             .setIn(['currentOrder', 'orderLines'], newOrderLines)
             .delete('currentOrderLine')
    }
    case EDIT_ORDER_LINE:
      const orderline = state.getIn(['currentOrder', 'orderLines']).filter(item => item.get('id') === action.lineId).get(0)
      return state.set('currentOrderLine', orderline)
    case DELETE_ORDER_LINE: {
      const newOrderLines = state.getIn(['currentOrder', 'orderLines']).filter(item => item.get('id') !== action.lineId)
      return state.setIn(['currentOrder', 'orderLines'], newOrderLines)
    }
    case SET_ORDER_LINE_STATUS: {
      const orderIndex = state.get('orders').findIndex(o => o.get('id') === action.orderId);
      const orderLineIndex = state.getIn(['orders', orderIndex, 'orderLines']).findIndex(ol => ol.get('id') === action.lineId)
      const newState = state.setIn(['orders', orderIndex, 'orderLines', orderLineIndex, 'status'], action.newStatus);
      return newState;
    }
    case CREATE_NEW_ORDER:
      const newOrder = emptyOrder.set('id', action.order).set('date', Date.now())
      const newState = state.set('currentOrder', newOrder)
      return newState
    case VIEW_ORDER:
      const order = state.get('orders').filter(item => item.get('id') === action.orderId).get(0)
      return state.set('currentOrder', order)
    case CANCEL_ORDER:
      return state.set('currentOrder', emptyOrder)
    case EDIT_ORDER:{
      const orderId = action.order;
      if (state.get('isLoading')) {
        console.log('state not fully loaded')
        return state; 
      }
      if (state.getIn(['currentOrder', 'id']) === orderId) {
        console.log('We are already editing an order')
        return state; 
      }
      const orderInList = state.get('orders').find(o => o.get('id') === orderId);
      if (orderInList !== undefined){
        console.log('It\'s a previous order. We edit it')
        return state.set('currentOrder', orderInList)
      }
      console.log('It\'s a new order. We create it')
      return state.set('currentOrder', emptyOrder.set('id', orderId).set('date', Date.now()))
    }
    case STORE_ORDER: {//this goes through SAVE_ORDER but doesn't trigger the epic
      const responseOrder = fromJS(action.order);
      const isCurrentOrder = state.getIn(['currentOrder', 'id']) === responseOrder.get('id');
      const newState =  stateSaveOrder(state)(responseOrder);
      const merged = newState.getIn(['currentOrder', 'orderLines']) 
      ? newState.getIn(['currentOrder', 'orderLines']).mergeDeep(responseOrder.get('orderLines'))
      : responseOrder.get('orderLines')
      const finalState =  isCurrentOrder
        ? newState.setIn(['currentOrder', 'orderLines'], merged)
        : newState
      return finalState;
    }
    case SAVE_ORDER: {
      const responseOrder = fromJS(action.order);
      return (stateSaveOrder(state)(responseOrder)).delete('currentOrder').delete('currentOrderLine');
    }
    case DELETE_ORDER: {
      const newState = state.set('deleteOrderDialogVisible', false)
      return newState
    }
    case DONE_ORDER: {
      let orders = state.get('orders')
      orders = orders.update(
        orders.findIndex(function (item) {
          return item.get('id') === action.orderId
        }), function (item) {
          return item.set('done', action.value)
        }
      )
      return state.set('orders', orders)
    }
    case SHOW_ALL_ORDERS:
      return state.set('showingAllOrders', action.isInputChecked)
    case SET_SEARCH_TEXT:
      return state.set('searchText', action.searchText)
    case SHOW_PENDING_ORDERS:
      return state.set('showPendingOrders', action.isInputChecked)
    case OPEN_DELETE_ORDER_DIALOG:
      return state.set('deleteOrderDialogVisible', true).set('currentOrder', action.order)
    case CLOSE_DELETE_ORDER_DIALOG:
      return state.set('deleteOrderDialogVisible', false)
    case FETCH_OPTIONS_SUCCESS:
      return state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/ordersDuck.js